import { render, staticRenderFns } from "./_wbetWidget.vue?vue&type=template&id=2b0cc8aa&scoped=true&lang=pug&"
import script from "./_wbetWidget.vue?vue&type=script&lang=js&"
export * from "./_wbetWidget.vue?vue&type=script&lang=js&"
import style0 from "./_wbetWidget.vue?vue&type=style&index=0&id=2b0cc8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0cc8aa",
  null
  
)

export default component.exports